export type MultipleChoiceContent = {
    questions: unknown[]
}